import React, { useEffect, useState } from "react";
import {
  getRequest,
  postRequest,
} from "../../../../../../services/api/apiService";
import { toast } from "react-toastify";

// Connexion Hotmart — saisie d'identifiants, pas de tunnel OAuth.
// Hotmart fonctionne en `client_credentials` : chaque marchand crée sa propre
// application sur developers.hotmart.com et en récupère un Client ID et un
// Client Secret. Le serveur les valide auprès de Hotmart AVANT de les stocker,
// et ne renvoie jamais le secret ensuite.
const ConnectedPlatformAccountHotmartConfigurationModal = ({
  platformName,
  headers,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getRequest("/api/hotmart/status", { ...headers })
      .then((r) => { if (!cancelled) setStatus(r); })
      .catch(() => { if (!cancelled) setStatus({ connected: false }); });
    return () => { cancelled = true; };
  }, [headers]);

  const connect = async () => {
    if (!clientId.trim() || !clientSecret.trim()) {
      setError("Renseignez le Client ID et le Client Secret.");
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const r = await postRequest(
        "/api/hotmart/connect",
        { clientId: clientId.trim(), clientSecret: clientSecret.trim() },
        { ...headers }
      );
      toast.success("Hotmart connecté ✅");
      setStatus({ connected: true, expiresAt: r?.expiresAt });
      setClientSecret("");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      // Le serveur remonte le motif exact (identifiants refusés, etc.).
      setError(err?.response?.data?.message || "Échec de connexion à Hotmart.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {status?.connected && (
        <div className="mb-4 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm">
          Déjà connecté{status.clientId ? ` (Client ID ${status.clientId})` : ""}.
          {status.expiresAt && (
            <span className="block text-xs text-emerald-600 mt-0.5">
              Jeton valide jusqu'au {new Date(status.expiresAt).toLocaleString("fr-FR")}
            </span>
          )}
          <span className="block text-xs text-emerald-600 mt-1">
            Ressaisir des identifiants remplacera la connexion actuelle.
          </span>
        </div>
      )}

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Client ID Hotmart
          </label>
          <input
            type="text"
            value={clientId}
            onChange={(e) => setClientId(e.target.value)}
            placeholder="Client ID de votre application Hotmart"
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-orange-500 focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Client Secret Hotmart
          </label>
          <input
            type="password"
            value={clientSecret}
            onChange={(e) => setClientSecret(e.target.value)}
            placeholder="Client Secret"
            autoComplete="off"
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-orange-500 focus:outline-none"
          />
        </div>
      </div>

      <div className="text-xs text-gray-500 italic my-4">
        Créez une application sur{" "}
        <a
          href="https://developers.hotmart.com"
          target="_blank"
          rel="noreferrer"
          className="underline text-orange-600"
        >
          developers.hotmart.com
        </a>{" "}
        pour obtenir ces identifiants. Ils sont vérifiés auprès de Hotmart avant
        d'être enregistrés, et le secret n'est jamais réaffiché.
      </div>

      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Annuler
        </button>
        <button
          onClick={connect}
          disabled={loading}
          className="px-4 py-2 bg-[#F04E23] text-white rounded-lg hover:bg-[#d84318] disabled:bg-gray-400"
        >
          {loading ? "Vérification…" : "Connecter"}
        </button>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountHotmartConfigurationModal;
